const Fuchsia = {
  Fuchsia: {
    _100: '#FAE8FF',
    _500: '#D946EF',
  },
};

export default Fuchsia;
